import React, { useEffect, useState } from "react";

export default function TableauDeBord() {
  const [commandes, setCommandes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    fetch("/api/TableauDeBord.php", { credentials: "include" })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setCommandes(data);
        } else {
          setCommandes([]);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Erreur chargement commandes", err);
        setLoading(false);
      });
  }, []);

  const updateStatutAdmin = (commandeId, statut) => {
    fetch("/api/updateTableau.php", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ commandeId, statut_admin: statut })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setCommandes(prev =>
            prev.map(c =>
              c.id === commandeId ? { ...c, statut_admin: statut } : c
            )
          );
        }
      })
      .catch(err => console.error(err));
  };

  const commandesFiltrees = commandes.filter(cmd =>
    filter === "all" ? true : cmd.statut_admin === filter
  );

  if (loading) return <p>Chargement des commandes…</p>;

  return (
    <div className="tableau-container">
      <h2>Tableau de bord – Commandes</h2>

      {/* Filtre */}
      <div style={{ marginBottom: "15px" }}>
        <label>Filtrer : </label>
        <select value={filter} onChange={e => setFilter(e.target.value)}>
          <option value="all">Toutes</option>
          <option value="À préparer">À préparer</option>
          <option value="Préparée">Préparée</option>
          <option value="Envoyée">Envoyée</option>
        </select>
      </div>

      {commandesFiltrees.length === 0 ? (
        <p>Aucune commande.</p>
      ) : (
        commandesFiltrees.map(cmd => (
          <div
            key={cmd.id}
            className="commandes-box"
            style={{
              borderLeft:
                cmd.statut_admin === "À préparer"
                  ? "5px solid red"
                  : cmd.statut_admin === "Préparée"
                  ? "5px solid orange"
                  : "5px solid green",
            }}
          >
            {/* Infos commande */}
            <div className="commandes-label">
              <div><strong>Réf :</strong> {cmd.reference}</div>
              <div><strong>Client :</strong> {cmd.client_prenom} {cmd.client_nom} ({cmd.client_email})</div>
              <div><strong>Téléphone :</strong> {cmd.client_telephone || '—'}</div>
              <div><strong>Livraison :</strong> {cmd.adresse_livraison}</div>
              <div><strong>Date :</strong> {new Date(cmd.date_commande).toLocaleDateString("fr-FR")}</div>
              <div><strong>Total :</strong> {Number(cmd.total).toFixed(2)} €</div>
              {cmd.remise > 0 && (
                <div><strong>Remise :</strong> {Number(cmd.remise).toFixed(2)} €</div>
              )}

              <div style={{ marginTop: "8px", gridColumn: '4' }}>
                <strong>Statut paiement :</strong>{" "}
                <span style={{ color: cmd.statut?.toLowerCase().trim() === 'payée' ? 'green' : 'red' }}>
                  {cmd.statut || 'en attente'}
                </span>
              </div>

              {/* Statut admin */}
              <div style={{ marginTop: "8px", gridColumn: '5' }}>
                <strong>Statut :</strong>{" "}
                <select
                  value={cmd.statut_admin || "À préparer"}
                  onChange={e => updateStatutAdmin(cmd.id, e.target.value)}
                >
                  <option value="À préparer">À préparer</option>
                  <option value="Préparée">Préparée</option>
                  <option value="Envoyée">Envoyée</option>
                </select>
              </div>
            </div>

            {/* Produits */}
            <div className="produit-box">
              {cmd.cart.length === 0 ? (
                <p>Aucun produit</p>
              ) : (
                cmd.cart.map((p, idx) => (
                  <div key={idx} className="produit-items">
                    <a href={`/produit/${p.produit_id}`}>
                      <img className='produit-img' src={`/static/media/${p.image}`} alt={p.nom}/>
                    </a>
                    <div className="produit-desc">
                      <strong><p className='produit-desc-img'>Article : {p.nom}</p></strong>
                      <strong>{p.gout && <p>Goût : {p.gout}</p>}</strong>
                      <strong><p>Qté : {p.quantity}</p></strong>
                    </div>
                    <div className="produit-total">
                      {(p.price * p.quantity).toFixed(2)} €
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
}